import { MultiSelectOption } from '@/types';

export interface CityOption extends MultiSelectOption {
    state?: string;
}
